import * as React from "react";
import { Input, type InputProps } from "../atoms/input";
import { cn } from "../../lib/utils";

export interface SearchInputProps extends InputProps {
	onClear?: () => void;
	hasValue?: boolean;
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
	({ className, onClear, hasValue, ...props }, ref) => {
		return (
			<div className={cn("relative", className)}>
				<svg
					className="w-3 h-3 text-gray-400 absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					viewBox="0 0 24 24"
					aria-hidden
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
					/>
				</svg>
				<Input ref={ref} className="pl-7 !py-1.5" {...props} />
				{hasValue && onClear && (
					<button
						type="button"
						onClick={onClear}
						className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
						aria-label="Clear search"
					>
						<svg
							className="w-3 h-3"
							fill="none"
							stroke="currentColor"
							strokeWidth="2"
							viewBox="0 0 24 24"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M6 18L18 6M6 6l12 12"
							/>
						</svg>
					</button>
				)}
			</div>
		);
	},
);
SearchInput.displayName = "SearchInput";

export { SearchInput };
